import React from 'react';
import { Box, Container as RContainer } from '@chakra-ui/react';
import Head from './Head';

const Container = ({ children }) => (
  <Box my="10" maxW="420px" flexGrow="1" borderRadius={8} overflow="hidden" border="1px" borderColor="gray.800">
    <Head />
    <RContainer py="6">
      {children}
    </RContainer>
  </Box>
);

export default Container;
